import React, { forwardRef, HTMLInputTypeAttribute } from 'react';
import type { FieldError } from 'react-hook-form';

import { styles } from './styles';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: FieldError;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
}

const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  ({ className, autoComplete, error, type = 'text', ...props }, ref) => {
    return (
      <input
        className={`${error ? styles.inputError : styles.inputClean} ${className}`}
        autoComplete={typeof autoComplete === 'undefined' ? undefined : autoComplete.toString()}
        type={type}
        ref={ref}
        {...props}
      />
    );
  }
);

// context here: https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/display-name.md
FormInput.displayName = 'FormInput';

export default FormInput;
